import { RouteRecordRaw } from "vue-router";
import { requireAuth } from "../guards/auth.guard";
import DashboardTasksPage from "@/views/v2/dashboard/DashboardTasksPage.vue";
import DashboardSitesPage from "@/views/v2/dashboard/DashboardSitesPage.vue";

export const DashboardRoutes: Array<RouteRecordRaw> = [
  {
    path: "/dashboard/sites",
    name: "DashboardSites",
    component: DashboardSitesPage,
    beforeEnter: requireAuth,
    meta: {
      title: "Sites"
    }
  },
  {
    path: "/dashboard/sites/:key/tasks",
    name: "DashboardTasks",
    component: DashboardTasksPage,
    beforeEnter: requireAuth,
    meta: {
      title: "Tasks"
    }
  },
];
